import type { FlashSession } from '../types'

export type SessionDisplayState = 'past' | 'active' | 'upcoming'
export type FlashActionTone = 'active' | 'upcoming' | 'soldout'

export function flashActionPresentation(state: SessionDisplayState, soldOut: boolean): { label: string; tone: FlashActionTone } {
  if (soldOut) return { label: '已抢完', tone: 'soldout' }
  if (state === 'active' || state === 'past') return { label: '正在疯抢', tone: 'active' }
  return { label: '即将开始', tone: 'upcoming' }
}

function sessionMinute(session: Pick<FlashSession, 'title' | 'startTime'>): number {
  const titleTime = session.title.match(/(?:^|\s)(\d{1,2}):(\d{2})(?:\s|$)/)
  if (titleTime) return Number(titleTime[1]) * 60 + Number(titleTime[2])
  const start = new Date(session.startTime)
  return Number.isNaN(start.getTime()) ? 0 : start.getHours() * 60 + start.getMinutes()
}

export function currentSessionIndex(sessions: Array<Pick<FlashSession, 'title' | 'startTime'>>, now = new Date()): number {
  if (!sessions.length) return 0
  const nowMinute = now.getHours() * 60 + now.getMinutes()
  let result = 0
  let latestMinute = -1
  sessions.forEach((session, index) => {
    const minute = sessionMinute(session)
    if (minute <= nowMinute && minute >= latestMinute) {
      latestMinute = minute
      result = index
    }
  })
  return result
}

export function sessionDisplayState(session: Pick<FlashSession, 'title' | 'startTime'>, sessions: Array<Pick<FlashSession, 'title' | 'startTime'>>, now = new Date()): SessionDisplayState {
  const activeMinute = sessionMinute(sessions[currentSessionIndex(sessions, now)])
  const minute = sessionMinute(session)
  if (minute === activeMinute) return 'active'
  return minute < activeMinute ? 'past' : 'upcoming'
}

export function countdownToMidnight(now = new Date()): string {
  const midnight = new Date(now)
  midnight.setHours(24, 0, 0, 0)
  const value = Math.max(0, midnight.getTime() - now.getTime())
  const hours = Math.floor(value / 3_600_000)
  const minutes = Math.floor(value / 60_000) % 60
  const seconds = Math.floor(value / 1_000) % 60
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

export function countdownToSession(session: Pick<FlashSession, 'title' | 'startTime'>, now = new Date(), dayOffset = 0): string {
  const target = new Date(now)
  target.setDate(target.getDate() + dayOffset)
  const minute = sessionMinute(session)
  target.setHours(Math.floor(minute / 60), minute % 60, 0, 0)
  const value = Math.max(0, target.getTime() - now.getTime())
  const hours = Math.floor(value / 3_600_000)
  const minutes = Math.floor(value / 60_000) % 60
  const seconds = Math.floor(value / 1_000) % 60
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}
